module.exports = __webpack_public_path__ + "static/media/oulis.d7a7925b.png";